"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var TelephoneInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TelephoneInput, _React$Component);

  function TelephoneInput(props) {
    var _this;

    _classCallCheck(this, TelephoneInput);

    _this = _possibleConstructorReturn(this, (TelephoneInput.__proto__ || Object.getPrototypeOf(TelephoneInput)).call(this, props));
    _this.state = {
      phone: props.value || '',
      error: {}
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TelephoneInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this2 = this;

      if (prevProps.value !== this.props.value) {
        this.setState(function (state) {
          state.phone = _this2.props.value;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var error = this.state.error[this.props.name] ? this.state.error : this.props.errors;
      var label = this.props.label || (0, _utils.capitalizeFirstLetter)(props.name),
          placeholder = "".concat(props.t('Enter a value for'), ": ").concat(label),
          hasError = error[props.name],
          errorMsg = '';

      if (hasError) {
        errorMsg = error[props.name].map(function (errorMsg) {
          return props.t(errorMsg);
        }).join(', ');
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        className: ['input', hasError ? 'error' : '', props.readOnly ? 'read-only' : ''].join(' ')
      }, label, /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: props.type,
        name: props.name,
        value: this.state.phone,
        placeholder: placeholder,
        readOnly: props.readOnly,
        onBlur: props.onBlur ? props.onBlur : void 0,
        onChange: this.handleChange,
        disabled: props.disabled
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__error"
      }, errorMsg));
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, name) {
      var value = e.target.value,
          maxLength = 17;

      if (!name) {
        var targetLen = value.length,
            stateLen = this.state.phone.length;

        if (stateLen >= targetLen) {
          value = value.trim();
        } else if (value.startsWith('+41')) {
          maxLength = 16;

          if (stateLen === 3 || stateLen === 6 || stateLen === 10 || stateLen === 13) {
            value = "".concat(value.slice(0, targetLen - 1), " ").concat(value.slice(-1)).trim();
          }
        } else if (value.startsWith('+423')) {
          // this is the only one we know for phone numbers of liechtenstein.
          // after that it can continue with +423 76 (for mobile) or +423 456 (for landline)
          // so we have to let the user format the number manually
          if (stateLen === 4) {
            value = "".concat(value.slice(0, targetLen - 1), " ").concat(value.slice(-1)).trim();
          }
        } // prevent further input after maxLength of the input is reached


        if (value.length > maxLength) {
          value = value.slice(0, -1);
        } // prevent inputs that are not allowed (allowed characters are numbers, + and whitespace)


        if (isNaN(value.slice(-1)) && ![' ', '+'].includes(value.slice(-1))) {
          value = value.slice(0, -1);
        }

        if (!isNaN(value.slice(-1))) {
          value = this.state.phone === '' && value !== '+' ? "+".concat(value) : value;
        }
      } else {
        value = '';
      }

      this.setState(function (prev) {
        prev.phone = value;
        return prev;
      });
      this.testPhone(value);
      this.props.onChange(e, this.props.name, value);
    }
  }, {
    key: "testPhone",
    value: function testPhone(phone) {
      var regExCH = RegExp(/^\+41\s\d{2}\s\d{3}\s\d{2}\s\d{2}$/),
          regExLI = RegExp(/^\+423\s\d{3}\s\d{2}\s\d{2}$/),
          regExLIMob = RegExp(/^\+423\s\d{2}\s\d{3}\s\d{2}\s\d{2}$/);

      if (regExCH.test(phone) || regExLI.test(phone) || regExLIMob.test(phone) || !phone.length) {
        this.setState(function (state) {
          state.error = {};
        });
      } else {
        this.setState(function (state, props) {
          state.error[props.name] = ['phone-number-invalid'];
        });
      }
    }
  }]);

  return TelephoneInput;
}(_react.default.Component);

;
TelephoneInput.defaultProps = {
  type: 'text',
  readOnly: false,
  errors: {},
  disabled: false
};
TelephoneInput.propTypes = {
  t: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  errors: _propTypes.default.any,
  disabled: _propTypes.default.bool
};
var _default = TelephoneInput;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/input-telephone.js
// module id = 544
// module chunks = 0